import Action from "../base/action";

class GlbAnimation extends Action {
    animationName;
    play;
    animationLoop;
    constructor(props) {
        super(props);
        this.model = props.model;
        this.animationName = props.animationName;
        this.status = props.status;
        this.endStatus = props.endStatus
    }

    static animationStatus = Object.freeze({
        PLAY: "play",
        PAUSE: "pause",
        STOP: "stop"
    });

    async execute({training}) {
        const modelResourceId = training.resources[this.model.id].resourceId;
        switch (this.status) {
            case GlbAnimation.animationStatus.PLAY:
                modelManager.playAnimation(modelResourceId, this.animationName, GLBAnimationEndEnum.LOOP === this.endStatus, this.endStatus);
                break;
            case GlbAnimation.animationStatus.PAUSE:
                modelManager.pauseAnimation(modelResourceId);
                break;
            case GlbAnimation.animationStatus.STOP:
                modelManager.stopAnimation(modelResourceId);
                break;
        }
    }
}

export default GlbAnimation;